module.exports = __webpack_public_path__ + "media/images/marisol-multimarcas-80970556417b542d331ea31a4deca1c8.jpg";